import { create } from "zustand";

interface OrgContextState {
  orgId: string | null;
  setOrgId: (orgId: string | null) => void;
}

export const useOrgStore = create<OrgContextState>((set) => ({
  orgId: null,
  setOrgId: (orgId) => set({ orgId }),
}));

/** Reactive hook — use in React components and hooks that need re-render on org change */
export function useOrgId() {
  return useOrgStore((s) => s.orgId);
}

/** Non-reactive getter — use in non-React code (e.g., api-client.ts) */
export function getCurrentOrgId(): string | null {
  return useOrgStore.getState().orgId;
}

/** Setter — called by OrgLayout on mount/unmount */
export function setCurrentOrgId(orgId: string | null) {
  useOrgStore.getState().setOrgId(orgId);
}
